import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPI } from "./api";
import dscpComposition from "./composition";
import help from "help/viewDSCPProfileConfig.md";
import settingsHelp from "help/viewDSCPProfileConfigSettings.md";

const ConfigDSCPProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...dscpComposition}
    {...composedAPI}
    {...settings}
    help={help}
    settingsHelp={settingsHelp}
  />
);

export default ConfigDSCPProfiles;
